import { z } from 'zod'

/** Private local integration. Price is the complete customer total, never factory cost. */
export const manufacturingApprovalSchema = z
  .object({
    operation_id: z.uuid(),
    publication_id: z.string().min(1).max(100),
    version: z.number().int().positive(),
    consent: z.literal(true),
  })
  .strict()
export const manufacturingPublishSchema = z
  .object({
    operation_id: z.uuid(),
    offer_id: z.string().min(1).max(100),
    customer_amount: z.union([z.number().int().positive(), z.string().regex(/^[1-9]\d*$/)]),
    customer_terms: z.string().min(1).max(4000),
    valid_until: z.string().datetime({ offset: true }),
  })
  .strict()
export interface ManufacturingRequest {
  id: string
  external_request_id: string
  product: string
  quantity: string
  unit: string
  unit_weight: string
  stage: string
  status: string
}
export interface ManufacturingQuote {
  id: string
  request_id: string
  version: number
  status: string
  product: string
  requested_quantity: string
  proposed_quantity: string
  unit: string
  unit_weight: string
  stage: string
  customer_amount: string
  currency: string
  price_basis: string
  customer_terms: string
  valid_until: string
  published_at: string
  approved_at?: string
  can_approve: boolean
}
export interface ManufacturingWorkspace {
  enabled: boolean
  local_only: boolean
  request_id?: string
  requests: ManufacturingRequest[]
  quotes: ManufacturingQuote[]
  mode?: 'local' | 'sync'
  managed?: boolean
  available?: boolean
  intake_available?: boolean
  synced_at?: number
  jobs?: Array<{ id: string; status: string; kind: string; error_code: string | null }>
  orders?: Array<{ id: string; request_id: string; status: string; quantity: string; unit: string }>
}
